import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule} from '@angular/forms'
import { QuestionConditionsComponent } from './question-conditions.component'

@NgModule({
  imports:[CommonModule,FormsModule],
  declarations:[QuestionConditionsComponent],
  exports:[QuestionConditionsComponent]
})
export class QuestionConditionsModule { }



